// extracted by mini-css-extract-plugin
export default {"attachmentCellRoot":"AttachmentsCell_attachmentCellRoot__6bQEz"};